export const checkRoleScope = (roleScope, scope, access) => {
  return (roleScope?.[scope] && roleScope?.[scope].includes(access)) || false;
};
